import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { gsap } from 'gsap'
import CustomEase from "@/utils/CustomEase";
import { setFPS } from '@/utils/FrameToTime'



import { Component, defineComponent, nextTick, onMounted, ref, ComponentPublicInstance } from 'vue'
import Logo from '@/assets/icons/logo-nationalgalerie.svg'

const __default__ = defineComponent({
  components: {
    Logo
  }
})

function setup(__props, { emit }: { emit: ({
  (e: 'done'): void
}), expose: any, slots: any, attrs: any }) {

gsap.registerPlugin(CustomEase)

const root = ref<HTMLDivElement>(null)
const background = ref<HTMLDivElement>(null)
const icon = ref<ComponentPublicInstance>(null)
const frames = setFPS(60)



onMounted(() => {
  nextTick(fadeOut)
})

function fadeOut() {


  const tl = gsap.timeline({
    delay: 1,
    onComplete: () => {
      
    }
  })
  tl
    .to(icon.value.$el, {
      autoAlpha: 0,
      ease: 'customOut',
    }, frames(0.283 * 60))
    .to(background.value, {
      autoAlpha: 0,
      ease: 'customOut',
      onStart: () => {
        emit('done')
      }
    }, frames(0.483 * 60))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "PreLoader",
    ref: (_value, _refs) => {
      _refs['root'] = _value
      root.value = _value
    }
  }, [
    _createElementVNode("div", {
      ref: (_value, _refs) => {
        _refs['background'] = _value
        background.value = _value
      },
      class: "PreLoader__Background"
    }, null, 512),
    _createVNode(_unref(Logo), {
      ref: (_value, _refs) => {
        _refs['icon'] = _value
        icon.value = _value
      },
      class: "PreLoader__Brand"
    }, null, 512)
  ], 512))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["done"],
  setup})